export default data =>
    Math.max.apply(Math, data);
